import {format} from 'date-fns'
import {Menu} from '../modules/apps/pages/menus/core/_models'

export const GetMenuPermissions = (route: string) => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')

  const menuPermissions = permissions.filter((permission) => {
    return permission.rota === route
  })

  return menuPermissions
}

export function hasActionPermission(name: string, action: string) {
  const accessGroup = localStorage.getItem('protocolos_accessGroup')

  const parsedAccessGroup = JSON.parse(accessGroup || '{}')

  const menu: Menu = parsedAccessGroup.menu?.find((menu: Menu) => menu.nome === name)

  if (menu.acoes?.find((acao) => acao.nome === action)) {
    return true
  }

  return false
}

export function compararDatasCriacao(a, b) {
  const dataA = new Date(a.dataCriacao)
  const dataB = new Date(b.dataCriacao)

  if (dataA > dataB) {
    return -1
  }
  if (dataA < dataB) {
    return 1
  }
  return 0
}

export const FormatDate = (date: string | undefined) => {
  if (typeof date === 'undefined') {
    return 'Não recebido'
  }

  const formattedDate = format(new Date(date), 'dd/MM/yyyy HH:mm')

  return formattedDate
}

// const formatDate = (date: Date | undefined) => {
//   let message = 'Não recebido'

//   try {
//     if (date) {
//       message = format(date, 'dd/MM/yyyy')
//     }

//     return 'Não recebido'
//   } catch (error) {
//     return 'Não recebido'
//   }
// }
